export default __webpack_public_path__ + "static/media/article.fcffd68a.svg";